import { useMemo, useState } from 'react';
import { getPlaylistAssignmentsUrl, PlaylistAssignmentsPortalProgress, useFilteredPlaylistAssignmentsPortals } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { theme } from 'academy-common-lib/utils/Styling';
import { TABLE_PAGINATOR_SIZE, Table } from '../../table';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { UsersAvatarList } from '../../avatar';
import formatName from 'I18n/utils/formatName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsPortalsTableHeader = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.team"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.domain"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.members"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.users"
      })
    })]
  });
};
const PlaylistAssignmentsPortalsTableRow = portal => {
  const {
    playlistId,
    portal: {
      id: portalId,
      domain: portalDomain
    },
    assignees
  } = portal;
  const url = getPlaylistAssignmentsUrl(playlistId, portalId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalProgress, {
        portal: portal
      })
    }), /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          fontWeight: 500
        },
        children: portalDomain
      }), /*#__PURE__*/_jsx("div", {
        style: {
          color: theme.colors.EERIE
        },
        children: portalId
      })]
    }), /*#__PURE__*/_jsx("td", {
      style: {
        fontWeight: 500
      },
      children: assignees.length
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UsersAvatarList, {
        hasMoreHref: url,
        users: assignees.map(({
          firstName,
          lastName,
          userId,
          avatarHash
        }) => {
          return {
            displayName: formatName({
              firstName,
              lastName
            }),
            userId,
            avatarHash
          };
        })
      })
    })]
  });
};
const PlaylistAssignmentsPortalsTable = ({
  playlistId
}) => {
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsPortals,
    pageCount
  } = useFilteredPlaylistAssignmentsPortals({
    playlistId,
    page
  });
  const rows = useMemo(() => {
    const portalsRecord = new Map();
    if (playlistAssignmentsPortals) playlistAssignmentsPortals.forEach(portal => {
      portalsRecord.set(portal.portal.id.toString(), portal);
    });
    return portalsRecord;
  }, [playlistAssignmentsPortals]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Table, {
      renderHeader: () => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableHeader, {}),
      renderRow: data => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableRow, Object.assign({}, data)),
      rows: rows
    }), pageCount > 1 && /*#__PURE__*/_jsx(UIPaginator, {
      maxVisiblePageButtons: TABLE_PAGINATOR_SIZE,
      onPageChange: ({
        target: {
          value
        }
      }) => setPage(value),
      page: page,
      pageCount: pageCount
    })]
  });
};
export default PlaylistAssignmentsPortalsTable;